import React, {useEffect, useState } from 'react';
import NewsInfo from "../../components/layout/singlenews/NewsInfo";
import NewsList from "../../components/common/NewsList";
import {getKeywordAPI} from "../../apis/news_service";
import Loading from "../error/Loading";

const SingleNews = () => {
    const pathname = window.location.pathname.split('/')

    const [loading, setLoading] = useState(true)
    const [newsId, setNewsId] = useState(pathname[pathname.length - 1])
    const [keywords, setKeywords] = useState([]); // 뉴스 키워드 리스트 (첫번째 상자)
    const [keywordNewsList, setKeywordNewsList] = useState([]);

    const getKeywordList = (idx) => {
        getKeywordAPI(newsId).then(res => {
            if(res.length > 0){
                setKeywords(res)
                setKeywordNewsList(res[idx].newslist)
            }
            setLoading(false)
        })
    }

    useEffect(()=> {
        getKeywordList(0)
        return () => setLoading(true)
    },[])

    return (
        <div className='singlenews container'>
            <div className='inner_container'>
                <NewsInfo newsId={newsId} keywords={keywords} setKeywordNewsList={setKeywordNewsList}/>
                {
                    loading ? <Loading/> :
                        <>
                            <p className='title_sm'>키워드 이슈와 관련된 뉴스 확인하기</p>
                            <NewsList newsList={keywordNewsList} type='vertical' size='5'/>
                        </>
                }
            </div>
        </div>
    );
};

export default SingleNews;